import { render, staticRenderFns } from "./DisabledItems.vue?vue&type=template&id=01c8ab1c&"
import script from "./DisabledItems.vue?vue&type=script&lang=js&"
export * from "./DisabledItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports